export default __webpack_public_path__ + "83e7f1ccc3f7a94c2c21211aa773bbe4.svg";